var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"st",on:{"click":function($event){return _vm.scrollTop()}}},[_c('img',{staticStyle:{"width":"35px","height":"35px"},attrs:{"src":require("../assets/images/icon/common/scroll-top.svg"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }